import { createStyles, makeStyles } from '@material-ui/core';

const styles = () =>
  createStyles({
    badge: {
      alignItems: 'center',
      border: '1px solid',
      borderRadius: 14,
      display: 'inline-flex',
      fontSize: 11,
      fontWeight: 700,
      lineHeight: '16px',
      minHeight: 26,
      padding: '4px 8px',
      whiteSpace: 'nowrap',
    },
    icon: {
      fontSize: 15,
      marginRight: 5,
    },
  });

export default makeStyles(styles);
